module.exports = __webpack_public_path__ + "img/card1.c3ac3dbe.png";